var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6679 8.47879H19.4238C19.7016 8.47879 19.968 8.58914 20.1644 8.78557L22.6932 11.3143C22.8896 11.5107 23 11.7771 23 12.0549L23 15.8108C23 16.3893 22.531 16.8582 21.9525 16.8582L15.6679 16.8582M15.6679 8.47879V4.28906M15.6679 8.47879L15.6679 16.8582M15.6679 16.8582H1.00391",
    stroke: "#7647EE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14564 20.0005C5.3026 20.0005 6.2405 19.0626 6.2405 17.9057C6.2405 16.7487 5.3026 16.8582 4.14564 16.8582C2.98868 16.8582 2.05078 16.7487 2.05078 17.9057C2.05078 19.0626 2.98868 20.0005 4.14564 20.0005Z",
    stroke: "#7647EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3351 20.0005C9.49206 20.0005 10.43 19.0626 10.43 17.9057C10.43 16.7487 9.49206 16.8582 8.3351 16.8582C7.17814 16.8582 6.24023 16.7487 6.24023 17.9057C6.24023 19.0626 7.17814 20.0005 8.3351 20.0005Z",
    stroke: "#7647EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8097 20.0005C19.9667 20.0005 20.9046 19.0626 20.9046 17.9057C20.9046 16.7487 19.9667 16.8582 18.8097 16.8582C17.6527 16.8582 16.7148 16.7487 16.7148 17.9057C16.7148 19.0626 17.6527 20.0005 18.8097 20.0005Z",
    stroke: "#7647EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.19336,
    y: 7.43164,
    width: 5.23715,
    height: 4.18972,
    rx: 1.04743,
    stroke: "#7647EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.05078,
    y: 11.6211,
    width: 5.23715,
    height: 4.18972,
    rx: 1.04743,
    stroke: "#7647EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33618,
    y: 11.6211,
    width: 5.23715,
    height: 4.18972,
    rx: 1.04743,
    stroke: "#7647EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0326 9.94922H17.5303C17.2989 9.94922 17.1113 10.1368 17.1113 10.3682V11.6251C17.1113 11.8565 17.2989 12.0441 17.5303 12.0441H20.2896C20.6628 12.0441 20.8498 11.5928 20.5858 11.3288L19.3289 10.0719C19.2503 9.99336 19.1438 9.94922 19.0326 9.94922Z",
    stroke: "#7647EE",
    strokeWidth: 0.523715
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.755cc168e66255f3c3c141d4cf38ae13.svg";
export { ForwardRef as ReactComponent };